import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'landing-contact',
  styleUrl: 'landing-contact.css',
})
export class LandingContact {
  @Prop() titleCopy: string = 'How Can We Help';
  @Prop() hours: string = 'Mon - Fri: 8 a.m. - 8 p.m. ET, Sat: 9 a.m. - 6 p.m. ET';
  @Prop() phone: string = '(866) 599-5268';
  @Prop() email: string = 'InstantCashOffer@KBB.com';
  @Prop() faqUrl: string = '';

  @Prop() whenFaqClicked = () => {};

  render() {
    return (
      <div class="text-center landing-contact-heading-text">
        <h2 class="text-2xl font-extrabold">{this.titleCopy}</h2>
        <div class="mt-5 landing-contact-base-font text-sm">{this.hours}</div>
        <div class="grid lg:grid-cols-3 max-w-4xl mx-auto mt-6 gap-y-7 justify-center landing-contact-base-font landing-contact-icon ">
          <div class="flex gap-x-3 justify-center">
            <svg-icon icon="phone-outline" width="20" height="25" />
            <ico-hyperlink href={`tel:${this.phone}`} noUnderline>
              {this.phone}
            </ico-hyperlink>
          </div>
          <div class="flex gap-x-3 justify-center">
            <svg-icon icon="mail" width="25" height="25" />
            <ico-hyperlink href={`mailto:${this.email}`} noUnderline class="whitespace-nowrap">
              {this.email}
            </ico-hyperlink>
          </div>
          <div class="flex gap-x-3 justify-center">
            <svg-icon icon="question-circle" width="20" height="25" />
            <ico-hyperlink
              href={this.faqUrl}
              noUnderline
              onClick={(e) => {
                this.whenFaqClicked();
                if (!this.faqUrl) {
                  e.preventDefault();
                }
              }}>
              Frequently Asked Questions
            </ico-hyperlink>
          </div>
        </div>
      </div>
    );
  }
}
